var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('eg-b-alert',{attrs:{"show":"","variant":"secondary"}},[_vm._v(" You’ll be redirected to Schoology to securely connect your account. After authorization, you’ll be automatically returned to this app. ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }